import React, { useEffect, useState } from "react";
import {
  FaCalendarAlt,
  FaClock,
  FaCheckCircle,
  FaExclamationTriangle,
  FaCog,
  FaBriefcase,
  FaBell,
  FaCoins,
  FaRupeeSign,
  FaUser,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../../styles/Header-css/ServicePartner/PartnerProfile/PartnerProfile.css";

const PartnerProfile = () => {
  const [partnerProfile, setPartnerProfile] = useState(null);

  const sampleBookings = [
    {
      id: 1,
      name: "Priya Sharma",
      time: "10:00 AM - 12:00 PM",
      address: "B-123, Lajpat Nagar, Delhi",
      price: "800",
      distance: "2.5 km",
      status: "Pending",
    },
    {
      id: 2,
      name: "Rahul Kumar",
      time: "02:00 PM - 03:00 PM",
      address: "C-456, DLF Phase 3, Gurgaon",
      price: "1500",
      distance: "5.2 km",
      status: "Accepted",
    },
    {
      id: 3,
      name: "Sneha Patel",
      time: "04:00 PM - 05:00 PM",
      address: "D-789, Lajpat Nagar, Delhi",
      price: "600",
      distance: "1.8 km",
      status: "Completed",
    },
  ];

  useEffect(() => {
    const storedProfile = localStorage.getItem("partnerProfile");
    if (storedProfile) {
      setPartnerProfile(JSON.parse(storedProfile));
    } else {
      const defaultProfile = {
        fullname: "Gisha",
        email: "gisha@example.com",
        phone: "9876543210",
        address: "B-123, Delhi",
      };
      setPartnerProfile(defaultProfile);
      localStorage.setItem("partnerProfile", JSON.stringify(defaultProfile));
    }
  }, []);

  return (
    <div className="partner-dashboard">
      {/* Header */}
      <header className="dashboard-header">
        <div className="profile-info">
          <FaUser className="profile-icon" />
          <div className="profile-details">
            <h2>Hello, {partnerProfile?.fullname}!</h2>
            <p>⭐ 4.8 • 1 job</p>
          </div>
        </div>

        <div className="status-toggle">
          <input type="checkbox" id="status-switch" defaultChecked />
          <label htmlFor="status-switch">Online</label>
        </div>

        <div className="header-actions">
          <button className="action-btn coins">
            <FaCoins /> <span>Coins</span>
          </button>
          <button className="action-btn earnings">
            <FaRupeeSign />
          </button>
          <button className="action-btn notifications">
            <FaBell />
          </button>
        </div>
      </header>

      {/* Quick Links */}
      <section className="quick-links">
       <Link to="/MyBookings" className="link-card no-underline">
          <FaCalendarAlt className="icon" />
          <p>Bookings</p>
          <strong>3 Pending</strong>
        </Link>

        <Link to="/schedule" className="link-card no-underline">
          <FaClock className="icon" />
          <p>Schedule</p>
          <strong>Manage slots</strong>
        </Link>

       <Link to="/EarningsDashboard" className="link-card no-underline">
          <FaRupeeSign className="icon" />
          <p>Earnings</p>
          <strong>View Details</strong>
        </Link>
      </section>

      {/* Info Cards */}
      <section className="info-card">
        <div className="card-header">
          <div className="time-summary">
            <div className="time-box available">
              <FaClock /> 3 Available Today
            </div>
            <div className="time-box booked">
              <FaCheckCircle /> 2 Booked Today
            </div>
          </div>
          <div className="total-hours">
            <p>This Week Total</p>
            <span>45 hours</span>
          </div>
          <div className="utilization-rate">
            <p>Utilization Rate</p>
            <span>50%</span>
          </div>
        </div>

        <div className="next-available-banner">
          <FaCalendarAlt />{" "}
          <p>
            <strong>Next Available</strong> Tomorrow 10:00 AM
          </p>
        </div>
      </section>

      <section className="info-card">
        <div className="job-stats">
          <div className="stat-item green">
            <FaCheckCircle /> <strong>3</strong>
            <p>Jobs Completed</p>
          </div>
          <div className="stat-item blue">
            <FaClock /> <strong>33</strong>
            <p>Scheduled</p>
          </div>
          <div className="stat-item orange">
            <FaExclamationTriangle /> <strong>13</strong>
            <p>Pending Jobs</p>
          </div>
        </div>

        <div className="progress-section">
          <p>Daily Target Progress</p>
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: "50%" }}></div>
          </div>
          <span>50% completed</span>
        </div>

        <div className="next-booking-banner">
          <FaCalendarAlt />{" "}
          <p>
            <strong>Next Booking</strong> 10:00 AM - House Cleaning
          </p>
        </div>
      </section>

      {/* Navigation */}
      <nav className="main-nav">
        <Link to="/schedule" className="nav-card no-underline">
          <FaCalendarAlt className="nav-icon" />
          <p>Schedule</p>
        </Link>

         <Link to="/MyServices" className="nav-card no-underline">
          <FaBriefcase className="nav-icon" />
          <p>Services</p>
        </Link>

        <Link to="/settings" className="nav-card no-underline">
          <FaCog className="nav-icon" />
          <p>Settings</p>
        </Link>
      </nav>

      {/* Recent Bookings */}
      <section className="recent-bookings">
        <div className="section-header">
          <h3>Recent Bookings</h3>
          <Link to="/MyBookings" className="no-underline">
            View All
          </Link>
        </div>

        <div className="booking-list">
          {sampleBookings.map((booking, index) => (
            <div className="booking-item" key={booking.id}>
              <div className="booking-item-header">
                <span className="booking-number">{index + 1}</span>
                <p className="customer-name">{booking.name}</p>
                <div
                  className={`status-tag ${booking.status.toLowerCase()}`}
                >
                  {booking.status}
                </div>
              </div>

              <div className="booking-item-body">
                <p>{booking.time}</p>
                <p>{booking.address}</p>
                <div className="booking-meta">
                  <span className="distance">{booking.distance}</span>
                  <span className="price">₹{booking.price}</span>
                </div>
              </div>

              <div className="booking-item-actions">
                {booking.status === "Pending" && (
                  <>
                    <button className="btn-reject">Reject</button>
                    <button className="btn-accept">Accept</button>
                  </>
                )}
                <button className="btn-details">View Details</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PartnerProfile;
